'use client';

import { IcFailoverH72 } from '@yanolja-rnd/nol-icons';
import { EmptyState } from '@yanolja-rnd/nol-design-system';
import { useEffect } from 'react';
import { captureException } from '@sentry/nextjs';
import { isSupportedAppVersion } from '@weberus/ui/utils/app-version-checker';
import { yaNative } from '@weberus/ui/utils/ya-native';

export default function ErrorPage({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    captureException(error);
  }, [error]);

  const handleClickRetry = async () => {
    const isSupported = await isSupportedAppVersion('9.4.0');

    if (!isSupported || !yaNative.isEnabled) {
      window.location.reload();
    } else {
      yaNative.reloadWebPage({});
    }
  };

  return (
    <div className="flex h-full w-full items-center justify-center bg-colors-white">
      <EmptyState
        icon={IcFailoverH72}
        title="네트워크 연결 상태가 좋지 않아요"
        description="연결 상태를 확인하고, 다시 시도해 주세요."
        buttons={[
          {
            content: '다시 시도하기',
            onClick: handleClickRetry,
          },
        ]}
      />
    </div>
  );
}
